const dayLabel = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("es-MX", { day: "2-digit", month: "short", timeZone: "UTC" });
};

export const DailyChart = ({ daily }) => {
  const max = Math.max(1, ...daily.map((d) => d.count));
  return (
    <section className="stats-card" data-testid="stats-daily-chart">
      <div className="stats-card-head">
        <h2>Últimos 14 días</h2>
        <span>Máximo: {max.toLocaleString("es-MX")}/día</span>
      </div>
      <div className="stats-chart">
        {daily.map(({ day, count }, i) => (
          <div key={day} className="stats-col" data-testid={`stats-day-${day}`} title={`${dayLabel(day)}: ${count}`}>
            <span className="stats-col-value">{count || ""}</span>
            <div className="stats-col-track">
              <div
                className={`stats-col-fill ${i === daily.length - 1 ? "today" : ""}`}
                style={{ height: `${Math.max(count ? 6 : 0, (count / max) * 100)}%` }}
              />
            </div>
            <span className="stats-col-label">{dayLabel(day)}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DailyChart;
